module.exports = __webpack_public_path__ + "c820a19ac32d9f26e5063c2a51449421.pdf";